/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { useDrop } from "react-dnd";
import { shouldMove } from "./should-move";
import { SortableItemTypes } from "./sortable-item-types";

/**
 * @param {string} id
 * @param {import('react').MutableRefObject<HTMLDivElement>} dropRef
 * @param {FindItem} find
 * @param {SwapItems} swap
 */
export function useItemDrop (id, dropRef, find, swap) {
    const dropOpts = useDrop({
        accept: SortableItemTypes.CONTENT,
        /**
         * @param {DragItem} item
         * @param monitor
         */
        hover (item, monitor) {
            const { id: draggedId, originalIndex } = item;
            if (draggedId === id || !dropRef.current) {
                return;
            }

            // Determine mouse position
            const clientOffset = monitor.getClientOffset();

            // Determine rectangle on screen
            const hoverBoundingRect = dropRef.current.getBoundingClientRect();
            const { index: hoverIndex } = find(id);

            const isMovable = shouldMove(
                hoverBoundingRect,
                clientOffset,
                originalIndex,
                hoverIndex,
            );

            if (isMovable) {
                swap(draggedId, hoverIndex);
            }
        },
    });

    return dropOpts;
}
